<template>
    <el-dialog
        title="新增用户"
        v-model="po.show"
        append-to-body
        :close-on-click-modal="false"
        width="40%"
        :before-close="close"
    >
        <el-form :model="po.userForm" ref="poFormRef" label-width="120px" :rules="rules">
            <input type="text" id="username" class="hidden" />
            <input type="text" id="password" class="hidden" />
            <el-form-item prop="username" label="用户名">
                <el-input v-model="po.userForm.username" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item prop="company_name" label="公司名">
                <el-input v-model="po.userForm.company_name" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item prop="realname" label="真实姓名">
                <el-input v-model="po.userForm.realname" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item prop="level" label="角色">
                <el-select v-model="po.userForm.level">
                    <el-option v-for="item in roleList" :key="item.level" :label="item.name" :value="item.level" />
                </el-select>
            </el-form-item>
            <el-form-item prop="isVip" label="VIP">
                <el-radio-group v-model="po.userForm.isVip">
                    <el-radio-button :label="1">是</el-radio-button>
                    <el-radio-button :label="0">否</el-radio-button>
                </el-radio-group>
            </el-form-item>
            <el-form-item prop="phone" label="Phone">
                <el-input v-model="po.userForm.phone"></el-input>
            </el-form-item>
        </el-form>
        <template #footer>
            <el-button @click="resetForm(poFormRef)">取 消</el-button>
            <el-button type="primary" @click="submitForm">确 认</el-button>
        </template>
    </el-dialog>
</template>
<script setup>
import request from '@/request/index.js';
import { ElMessage } from 'element-plus';
import { reactive, ref } from 'vue';
import { roleList } from '../user.js';
const props = defineProps({
    visible: Boolean,
    userInfo: Object
});
const emit = defineEmits(['parentCallback', 'closeDialog']);

const poFormRef = ref();

const rules = reactive({
    username: [{ required: true, trigger: 'change', message: '请输入用户名' }],
    level: [{ required: true, trigger: 'change', message: '请选择角色' }]
});
let po = reactive({
    show: false,
    userForm: props.userInfo,
    normalUserLists: []
});
// 根据应用查询角色级联信息
const queryNormalUsers = async function () {
    const result = await request('queryUserLists', {
        level: 2
    });
    const list = result.data.list;
    po.normalUserLists = list;
    po.show = props.visible;
};
queryNormalUsers();

const submitForm = () => {
    poFormRef.value.validate(async valid => {
        if (valid) {
            const requestMethod = po.userForm.id !== 0 ? 'updateUser' : 'addUser';
            const result = await request(requestMethod, po.userForm);
            if (result.status === 200) {
                ElMessage({ message: result.msg, type: 'success' });
            }
            emit('parentCallback');
        } else {
            console.log('error submit!');
            return false;
        }
    });
};
const close = () => {
    emit('closeDialog');
};
const resetForm = poFormRef => {
    poFormRef.resetFields();
    close();
};
</script>
<style lang="scss">
.selected-role__list {
    width: 100%;
    margin-bottom: 8px;
    flex-wrap: wrap;
}
.mgr {
    margin-right: 8px;
}
.mgt {
    margin-top: 8px;
}
.cascader-lists {
    width: 100%;
}
</style>
